if (!customElements.get('product-price-total')) {
  customElements.define(
    'product-price-total',
    class ProductPriceTotal extends HTMLElement {
      connectedCallback() {
        this.valueElement = this.querySelector('.product-price-total__value');
        this.priceSource = document.getElementById(this.dataset.priceSource);

        if (!this.valueElement || !this.priceSource) return;

        this.updateTotal();
        this.observer = new MutationObserver(() => this.updateTotal());
        this.observer.observe(this.priceSource, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      updateTotal() {
        const priceContainer = this.priceSource.querySelector('.price');
        const price = priceContainer?.classList.contains('price--on-sale')
          ? priceContainer.querySelector('.price__sale .price-item--sale')
          : priceContainer?.querySelector('.price__regular .price-item--regular:not(.variant-item__old-price)');
        const value = price?.textContent.trim();

        if (value && this.valueElement.textContent.trim() !== value) {
          this.valueElement.textContent = value;
        }
      }
    }
  );
}
